module.exports = __webpack_public_path__ + "img/hall1.66603f9d.jpg";